import { type ReactNode } from 'react';

import { Text } from '@soluto-private/mx-asurion-ui-react';

export type SectionTitleProps = {
  children: ReactNode;
};

export const SectionTitle = ({ children }: SectionTitleProps) => (
  <Text as="h2" size={3}>
    {children}
  </Text>
);
